export default "__VITE_ASSET__7e8aab59__"